import { useModalState } from "@clipboard-health/ui-components";
import { Box } from "@mui/material";
import { RootPaths } from "@src/appV2/App/paths";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { useLocalStorage } from "@src/appV2/lib/utils/useLocalstorage";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";
import { useHistory } from "react-router-dom";

import { useGetCbhWrappedInsights } from "./api/useGetCbhWrappedInsights";
import { CbhWrappedBanner } from "./Banner";
import { CbhWrappedBottomSheet } from "./BottomSheet";
import { CBH_WRAPPED_PATH } from "./paths";
import { useIsCbhWrappedEnabled } from "./useIsCbhWrappedEnabled";

export function CbhWrappedEntrypoint() {
  const isCbhWrappedEnabled = useIsCbhWrappedEnabled();

  const worker = useDefinedWorker();

  const [isBannerDismissed, setIsBannerDismissed] = useLocalStorage<boolean>(
    "cbh-wrapped-banner-dismissed",
    false
  );

  const modalState = useModalState(isBannerDismissed ? "closed" : "open");

  // this is needed to make sure closing the modal via backdrop calls setIsBannerDismissed
  modalState.closeModal = () => {
    setIsBannerDismissed(true);
    modalState.setModalStatus("closed");
  };

  const { data: wrappedInsights, isSuccess: isWrappedInsightsSuccess } = useGetCbhWrappedInsights({
    enabled: isCbhWrappedEnabled,
  });

  const history = useHistory();

  if (!isCbhWrappedEnabled) {
    return null;
  }

  if (!isWrappedInsightsSuccess || wrappedInsights?.data.length === 0) {
    return null;
  }

  return (
    <>
      <Box sx={{ marginX: 6, marginY: 4 }}>
        <CbhWrappedBanner
          onClick={() => {
            setIsBannerDismissed(true);
            history.push(`${RootPaths.APP_V2_HOME}/${CBH_WRAPPED_PATH}`);

            logEvent(APP_V2_USER_EVENTS.CBH_WRAPPED_PAGE_VIEWED, {
              source: "banner",
              workerId: worker.userId,
              totalInsights: wrappedInsights.data.length,
              insightTypes: wrappedInsights.data.map((insight) => insight.attributes.insightType),
            });
          }}
        />
      </Box>

      <CbhWrappedBottomSheet
        modalState={modalState}
        onClick={() => {
          modalState.closeModal();
          history.push(`${RootPaths.APP_V2_HOME}/${CBH_WRAPPED_PATH}`);

          logEvent(APP_V2_USER_EVENTS.CBH_WRAPPED_PAGE_VIEWED, {
            source: "bottomSheet",
            workerId: worker.userId,
            totalInsights: wrappedInsights.data.length,
            insightTypes: wrappedInsights.data.map((insight) => insight.attributes.insightType),
          });
        }}
      />
    </>
  );
}
